export const outsourcingSearchOptions = [
    {
        label: '直営',
        value: '1',
    },
    {
        label: '委託先',
        value: '2',
    },
]

export const outsourcingLabelMap = [
    {
        label: '直営',
        value: '1',
    },
    {
        label: '委託先',
        value: '2',
    },
    {
        label: '直営/委託先',
        value: '3',
    },
]

export const getOutsourcingFlag = (input) => {
    return outsourcingLabelMap.find((elem) => elem.value === input)
}

export const getDisplayOutsourcingFlag = (input) => {
    const result = getOutsourcingFlag(input)
    return result ? result.label : null
}
